import MappingError from "./MappingError";

export default MappingError;
